<template>
  <div class="exportContainer">
    <el-dialog title="导入文件" :visible.sync="dialogVisible" width="800px">
      <div class="stepContainer">
        <div class="container">
          <el-steps :active="step" simple>
            <el-step title="上传文件" icon="el-icon-upload"></el-step>
            <el-step title="导入完成" icon="el-icon-circle-check"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="export" v-if="step === 1">
        <div class="download">一、请按照数据模板的格式准备要导入的数据。 <el-button type="text" @click="handleDownload"> 点击下载模板 </el-button></div>
        <div class="selectExport">二、请选择需要导入的文件。</div>
        <div class="uploadContainer">
          <el-upload class="upload-demo" :on-change="handleChange" :on-remove="handleRemove" :auto-upload="false" :file-list="fileList" action="#">
            <el-button style="background-color: #008754; color: white">选择文件</el-button>
          </el-upload>
        </div>
        <div class="footerBtn">
          <el-button class="dialogWhite" @click="cancelBtn">取 消</el-button>
          <el-button class="dialogBtnBackgory" @click="submitBtn">确 定</el-button>
        </div>
      </div>
      <div v-if="step === 2">
        <div class="uploadSuccess">
          <div class="success">
            <i class="el-icon-circle-check" style="width: 50px; height: 50px"></i>
            <div>导入完成</div>
          </div>
        </div>
        <div class="footerBtn">
          <el-button class="dialogWhite" @click="successCancelBtn">取 消</el-button>
          <el-button class="dialogBtnBackgory" @click="successSubmitBtn">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "channel",
  props: ["type", "downloadTitle", "getSearchList"],
  data() {
    return {
      dialogVisible: false,
      upload: "",
      file: "",
      formDataPage: "",
      fileList: [],
      step: 1
    };
  },
  mounted() {
    this.upload = apis.upload;
  },
  methods: {
    // 上传
    handleChange(file) {
      this.fileList = [file];
    },
    // 删除
    handleRemove() {
      this.fileList = [];
    },
    // 取消
    cancelBtn() {
      this.fileList = [];
      this.dialogVisible = false;
      this.step = 1;
    },
    // 下载
    handleDownload() {
      apis.downloadData(this.type).then(res => {
        console.log('res11',res);
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `${this.downloadTitle}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    // 导入
    submitBtn() {
      if (this.fileList.length) {
        this.file = new FormData();
        this.file.append("file", this.fileList[0]?.raw);
        const json = {
          type: this.type,
          file: this.file
        };
        apis.exportData(json).then(res => {
          if (res.code === 200) {
            this.step = 2;
            this.$message({
              message: "导入成功",
              type: "success"
            });
          }
        });
      }
    },
    // 导入完成
    successCancelBtn() {
      this.fileList = [];
      this.dialogVisible = false;
      this.step = 1;
    },
    // 导入完成
    successSubmitBtn() {
      this.getSearchList({ page: 1, pageSize: 20 });
      this.dialogVisible = false;
      this.fileList = [];
      this.step = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-list {
  width: 500px;
}
.exportContainer {
  .stepContainer {
    display: flex;
    justify-content: center;
    .container {
      // width: 540px;
      // height: 54px
      width: 985px;
      height: 96px;
    }
  }
  .export {
    .download {
      margin-bottom: 90px;
      margin-top: 40px;
    }
    .selectExport {
      margin-bottom: 40px;
    }
    .uploadContainer {
      .upload-demo {
        margin-left: 55px;
      }
    }
  }
  .footerBtn {
    margin-top: 300px;
    text-align: right;
    .dialogWhite {
      width: 145px;
      height: 54px;
    }
    .dialogBtnBackgory {
      width: 145px;
      height: 54px;
      background-color: #008754;
      color: white;
    }
  }
  .uploadSuccess {
    display: flex;
    justify-content: center;
    margin-top: 90px;
    .success {
      ::v-deep .el-icon-circle-check {
        font-size: 92px;
        color: #008754;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
